/**
 * @generated SignedSource<<d47c88dd02b262effebd8a84bc76f41d>>
 * @relayHash 064eee3f34ccefab6b2c44396bae62eb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/579.0.0-2026-09-30T11:46:05.781Z/setUserHasConfirmedOrdersCookieMutation

import { ConcreteRequest } from 'relay-runtime';
export type SetUserHasConfirmedOrdersCookieInput = {
  clientMutationId?: string | null;
  cookieDomain?: string | null;
};
export type setUserHasConfirmedOrdersCookieMutation$variables = {
  input: SetUserHasConfirmedOrdersCookieInput;
};
export type setUserHasConfirmedOrdersCookieMutation$data = {
  readonly setUserHasConfirmedOrdersCookie: {
    readonly clientMutationId: string | null;
  } | null;
};
export type setUserHasConfirmedOrdersCookieMutation = {
  response: setUserHasConfirmedOrdersCookieMutation$data;
  variables: setUserHasConfirmedOrdersCookieMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetUserHasConfirmedOrdersCookiePayload",
    "kind": "LinkedField",
    "name": "setUserHasConfirmedOrdersCookie",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setUserHasConfirmedOrdersCookieMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "setUserHasConfirmedOrdersCookieMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ferrum/579.0.0-2026-09-30T11:46:05.781Z/setUserHasConfirmedOrdersCookieMutation",
    "metadata": {},
    "name": "setUserHasConfirmedOrdersCookieMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e4d02b82d8756d8b3eb208045e7d733a";

export default node;
